import { useEffect, useMemo, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { type Container, type ISourceOptions } from "@tsparticles/engine";
import { loadSlim } from "@tsparticles/slim";

const HeroParticleBackground = () => {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const particlesLoaded = async (container?: Container): Promise<void> => {
    console.log(container);
  };

  const options: ISourceOptions = useMemo(
    () => ({
      background: {
        color: {
          value: "transparent",
        },
      },
      fpsLimit: 120,
      interactivity: {
        events: {
          onClick: {
            enable: true,
            mode: "push",
          },
          onHover: {
            enable: true,
            mode: ["grab", "bubble"],
          },
          resize: {
            enable: true,
          },
        },
        modes: {
          push: {
            quantity: 2,
          },
          grab: {
            distance: 200,
            links: {
              blink: false,
              consent: false,
              opacity: 0.4, // Reduced for subtlety
            },
          },
          bubble: {
            distance: 200,
            size: 5,
            duration: 0.3,
            opacity: 0.5, // Reduced for subtlety
          },
          repulse: {
            distance: 100,
            duration: 0.4,
          },
        },
      },
      particles: {
        color: {
          value: ["#6366F1", "#3B82F6", "#8B5CF6"], // Subtle blue-purple mix
        },
        links: {
          color: "#6366F1",
          distance: 150,
          enable: true,
          opacity: 0.15, // Very subtle for hero
          width: 1, // Thinner lines
          triangles: {
            enable: false,
          },
        },
        move: {
          direction: "none",
          enable: true,
          outModes: {
            default: "bounce",
          },
          random: false,
          speed: 0.8, // Slower movement
          straight: false,
          attract: {
            enable: false,
            rotateX: 600,
            rotateY: 1200,
          },
        },
        number: {
          density: {
            enable: true,
            width: 1920,
            height: 1080,
          },
          value: 60, // Fewer particles for subtle effect
        },
        opacity: {
          value: { min: 0.2, max: 0.4 }, // Much lower opacity
          animation: {
            enable: true,
            speed: 1,
            sync: false,
          },
        },
        shape: {
          type: "circle",
        },
        size: {
          value: { min: 1, max: 3 }, // Smaller particles
        },
      },
      detectRetina: true,
    }),
    []
  );

  if (init) {
    return (
      <Particles
        id="hero-tsparticles"
        particlesLoaded={particlesLoaded}
        options={options}
        className="absolute inset-0 pointer-events-none"
      />
    );
  }

  return null;
};

export default HeroParticleBackground;
